<template>
  <div class="content">
    <img alt="Vue logo" src="../assets/logo.png">
    <h1>"This is a dummy page"</h1>
    <!-- <h2 v-if="this.DTitle.length > 0">Invoked from: {{this.DTitle}}</h2> -->
    <!-- <span>Route : {{$route.name.toUpperCase() }}<small>{{ $route.meta.description }}</small></span> -->
    <!-- <h1>--{{ DTitle }}</h1> -->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'Dummy',
  props: {
    DTitle: String,
  },
};
</script>
